import { defineStore } from 'pinia'
import { useAlertsStore } from '@/store/pinia/alerts'
import { useOrganizationStore } from '@/store/pinia/organization'

export const useInventoryStore = defineStore('inventory', {
  state: () => ({
    terraformOutputs: [],
    terraformOutputsCount: 0,
  }),

  actions: {
    async PIN_TERRAFORM_OUTPUT ({ orgCanonical, inventoryOutputId }) {
      const { errors } = await this.$cycloid.ydAPI.pinTerraformOutput(orgCanonical, inventoryOutputId) || {}
      const alertsStore = useAlertsStore()
      if (errors) return alertsStore.SHOW_ALERT({ type: 'error', content: errors })
    },

    async UNPIN_TERRAFORM_OUTPUT ({ orgCanonical, inventoryOutputId }) {
      const { errors } = await this.$cycloid.ydAPI.unpinTerraformOutput(orgCanonical, inventoryOutputId) || {}
      const alertsStore = useAlertsStore()
      if (errors) return alertsStore.SHOW_ALERT({ type: 'error', content: errors })
    },

    async GET_RESOURCE ({ orgCanonical, resourceId }) {
      const { data, errors } = await this.$cycloid.ydAPI.getResource(orgCanonical, resourceId) || {}
      const alertsStore = useAlertsStore()
      if (errors) return alertsStore.SHOW_ALERT({ type: 'error', content: errors })
      if (data) {
        const orgStore = useOrganizationStore()
        const index = orgStore.available.inventoryResources.findIndex((r) => r.id === resourceId)
        if (index !== -1) {
          orgStore.available.inventoryResources[index] = data
        } else {
          orgStore.available.inventoryResources.push(data)
        }
        return data
      }
    },

    async FETCH_TERRAFORM_OUTPUTS ({ orgCanonical, extraParams }) {
      const { data, errors, component_total: componentTotal } = await this.$cycloid.ydAPI.getTerraformOutputs(orgCanonical, ...extraParams) || {}
      const alertsStore = useAlertsStore()
      if (errors) return alertsStore.SHOW_ALERT({ type: 'error', content: errors })
      this.terraformOutputs = data
      this.terraformOutputsCount = componentTotal || 0
    },

    RESET_INVENTORY_RESOURCES () {
      const orgStore = useOrganizationStore()
      orgStore.available.inventoryResources = []
    },

    RESET_INVENTORY_STATE () {
      this.RESET_INVENTORY_RESOURCES()
      this.terraformOutputs = []
      this.terraformOutputsCount = 0
    },
  },

  getters: {
    getAttributes: () =>
      (resource) => resource?.attributes,
    getId: (state) =>
      (resource) => state.getAttributes(resource)?.id || resource?.id,
    getImage: () =>
      (resource) => {
        const { type, image } = resource

        if (type.startsWith('vault_')) return '/static/images/stackcraft/elements/default/vault.svg'
        if (image?.endsWith('.svg')) return image

        return null
      },
    getProvider: () =>
      (resource) => {
        return resource?.provider
      },
    getProviderTranslation: (state) =>
      (resource, key = 'abbreviation') => {
        const orgStore = useOrganizationStore()
        const { cloudProviders } = orgStore.available
        const matchingCloudProvider = _.find(
          cloudProviders,
          { canonical: state.getProvider(resource) },
        )
        const translation = matchingCloudProvider?.[key]
        return translation
      },
    getResource: () =>
      (id) => {
        const orgStore = useOrganizationStore()
        return _.find(
          orgStore.available.inventoryResources,
          { id },
        )
      },
  },
})
